import {
  CloudArrowUpIcon,
  CurrencyDollarIcon,
  GraphIcon,
  KeyboardIcon,
  KeyIcon,
  UserGroupIcon,
  UserIcon,
} from "@stacklet/ui";

import { SETTINGS_BREADCRUMB } from "app/constants/breadcrumbs";
import { paths } from "app/constants/paths";
import { useConfig } from "app/contexts/ConfigContext";
import { useHasScopePermission } from "app/hooks";

export function useSettingsBreadcrumbs() {
  const config = useConfig();
  const hasPermission = useHasScopePermission();
  const isAdmin = hasPermission("system", "EDIT");

  const adminTabs = isAdmin
    ? [
        {
          label: "Identity Providers",
          id: "settings-identity-providers",
          target: paths.identityProviders,
          section: "Users & Groups",
          icon: KeyIcon,
        },
        {
          label: "Users",
          id: "settings-users",
          target: paths.users,
          section: "Users & Groups",
          icon: UserIcon,
        },
        {
          label: "Groups",
          id: "settings-groups",
          target: paths.groups,
          section: "Users & Groups",
          icon: UserGroupIcon,
        },
        ...(config?.dev_flags.includes("admin-settings")
          ? [
              {
                label: "Access Model",
                target: paths.accessModel,
                section: "Clouds & Integrations",
                icon: KeyboardIcon,
              },
            ]
          : []),
        {
          label: "Clouds",
          target: paths.settingsClouds,
          section: "Clouds & Integrations",
          icon: CloudArrowUpIcon,
        },
        {
          label: "Cost",
          target: paths.settingsCost,
          section: "Clouds & Integrations",
          icon: CurrencyDollarIcon,
        },
        {
          label: "Integrations",
          target: paths.settingsIntegrations,
          section: "Clouds & Integrations",
          icon: GraphIcon,
        },
      ]
    : [];

  return [SETTINGS_BREADCRUMB, { tabs: adminTabs }];
}
